export default {
  form: {
    loading: false,
    error: false,
    success: false,
  },
};
